module.exports = __webpack_public_path__ + "media/scholarships/more-2e64e85c.svg";